import styled from 'styled-components';
import { COLOR } from '../../../../../theme/constants';

export const TableTitleCell = styled.td<{ level: string }>`
   font-size: 16px;
   padding: 17px 6px;
   position: relative;
   text-align: left;
   border-top: 1px solid ${COLOR.LIGHTGREY};

   ${props => {
      switch (props.level) {
         case 'L1':
            return `
          padding-left: 30px;
          color: ${COLOR.BLACK};
        `;
         case 'L2':
            return `
          padding-left: 30px;
          color: ${COLOR.GREY};
        `;
         case 'L3':
            return `
          padding-left: 30px;
          color: ${COLOR.GREY};
        `;
      }
   }}
`;

// Original L1 12px
// Original L2 24px
// Original L3 36px
